import NumberFormat from 'react-number-format';

const StdNumberFormat = ({ text }) => (
    <NumberFormat value={text} decimalScale={0} displayType="text" thousandSeparator="." decimalSeparator="," isNumericString prefix="" />
);
export default StdNumberFormat;
